module.exports = __webpack_public_path__ + "img/hik-cori-cam.b7f62e9d.png";